<template>
<section class="profile-friends">
    <template v-if="!loadingPage">
        <template v-if="!loggedOut">
            <div class="pull-right form-inline hidden-xs">
                <label for="pagination-show">{{ t.show }}</label>
                <select class="form-control" v-model.number="limit" @change="updateLimit">
                    <option :value="28">28</option>
                    <option :value="56">56</option>
                    <option :value="112">112</option>
                </select>
                <template v-if="owner">
                    <label for="friend-filter">{{ t.search }}</label>
                    <div class="input-group">
                        <input type="text" v-model="filter" @keyup.enter="fetch('filter')" class="form-control" :placeholder="t.username">
                        <span class="input-group-btn">
                            <button class="btn btn-default btn-primary" @click="fetch('filter')">{{ t.go }}</button>
                        </span>
                    </div>
                </template>
                <label for="friend-sort">{{ t.sort }}</label>
                <select v-model="sort" @change="fetch('sort')" class="form-control">
                    <option value="identity">{{ t.username }}</option>
                    <option value="online">{{ t.online }}</option>
                </select>
            </div>
        </template>
        <h1>{{ t.title }}</h1>
        <div :class="['profile-friends-list', 'profile-list', { 'current-friends': type === 'friend' }]" v-if="!loading" v-cloak>
            <user v-for="friend in friends" v-if="friends.length" :user="friend" :key="friend.id" :owner="owner">
                <ul v-if="type==='friend'" slot="menu" class="dropdown-menu">
                    <li><a href="#" @click.prevent="remove(friend)">{{ t.remove }}</a></li>
                    <li><a href="#" @click.prevent="remove(friend, true)">{{ t.remove_block }}</a></li>
                </ul>
            </user>
            <span v-if="!friends.length" v-text="t.empty_list"></span>
        </div>
    </template>

    <loading v-if="loading || loadingPage"></loading>
    <pagination v-if="friends.length && !loadingPage" :page="page" :total="totalPages" :top="scrollTop" @page-changed="pageChange"></pagination>
</section>
</template>

<script>
import ajax from 'Site/js/util/ajax.fetch';
import { getCookie, setCookie } from 'Site/js/util/cookie';
import Loading from 'Site/component/Loading.vue';
import Pagination from 'Site/component/Pagination.vue';
import User from 'Profile/component/User.vue';
import { mapActions, mapState } from 'vuex';

export default {
    name: 'FriendsAndFollowing',
    components: {
        Loading,
        Pagination,
        User,
    },
    computed: {
        ...mapState({
            owner: state => state.config.data.owner,
            routerConfig: state => state.config.data.router,
            user: state => state.config.data.userId
        }),
        offset() {
            return (this.page * this.limit) - this.limit;
        },
        page() {
            return parseInt(this.$route.params.page, 10) || 1;
        },
        totalPages() {
            return Math.ceil(this.numFriends / this.limit);
        }
    },
    data() {
        return {
            friends: [],
            filter: '',
            filterChanged: false,
            limit: parseInt(getCookie('profile-num-results'), 10) || 24,
            loading: false,
            loadingPage: true,
            numFriends: 0,
            scrollTop: document.getElementById('profile-vue').offsetHeight || 0,
            sort: 'identity',
            t: {},
            loggedOut: this.$store.state.config.loggedOut || false
        };
    },
    methods: {
        ...mapActions(['notify', 'showConfirm']),
        fetch(trigger = null) {
            if (trigger) {
                this.filterChanged = true;
                this.pageChange(1);
            }
            this.loading = true;
            ajax.get(this.type, {
                // reset start-index to 0 if any filter has just been changed
                'start-index': trigger ? 0 : this.offset,
                'max-results': this.limit,
                user: this.user,
                sort: this.sort,
                filter: this.filter
            }).then((response) => {
                this.numFriends = response.totalItems;
                this.friends = response.items;
                this.loading = false;
                this.filterChanged = false;
            });
        },
        remove(removeUser, block = false) {
            const confirmMessage = block ? this.t[`remove_${this.type}_and_block`] : this.t[`remove_${this.type}`];
            const buttonText = block ? this.t.remove_block : this.t.remove;
            this.showConfirm({
                buttonText,
                text: confirmMessage.replace('%username', removeUser.userName),
                callback: () => {
                    this.friends = this.friends.filter(friend => friend !== removeUser);
                    if (block) {
                        ajax.create(this.privacyEndpoint, { user: removeUser.id });
                    }
                    ajax.delete(this.type, { id: removeUser.id }).then((response) => {
                        this.notify({ msg: response.message });
                    });
                }
            });
        },
        pageChange(page) {
            let { type } = this;
            if (type === 'friend') {
                type += 's';
            }
            this.$router.push({ path: `${this.routerConfig[type]}/${this.routerConfig.parts.page}/${page}` });
        },
        updateLimit() {
            setCookie('profile-num-results', this.limit);
            this.fetch();
        },
        vouch(friend) {
            this.$emit('vouch', friend);
        }
    },
    created() {
        const setData = (settings, json = false) => {
            if (json) {
                settings = JSON.parse(settings);
            }
            this.friends = settings.data.friends;
            this.numFriends = settings.data.numFriends;
            this.privacyEndpoint = settings.endpoints ? settings.endpoints.privacy : '';
            this.t = settings.translate;
            this.loadingPage = false;
        };
        if (this.localConfig) {
            setData(this.localConfig);
        } else if (document.querySelector(`#${this.type}-json`)) {
            const settings = document.querySelector(`#${this.type}-json`).textContent;
            if (settings) {
                setData(settings, true);
            }
        } else {
            ajax.get(window.location.href).then((data) => {
                setData(data, true);
            });
        }
    },
    watch: {
        $route: function watchRoute() {
            // only call fetch on route change if change isn't triggered by a filter resetting the page to 1.
            if (!this.filterChanged) {
                this.fetch();
            }
            this.filterChanged = false;
        }
    },
    props: {
        type: {
            type: String,
            default: 'friends'
        },
        localConfig: {
            type: Object
        }
    }
};

</script>
